// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("cocoon")
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')
require('bootstrap')
require('website/bootstrap-select.min')
require('website/popper.min')
require('website/jquery-ui-1.10.1.custom.min')
require('website/jquery.jscroll')
require('website/jquery.timepicker.min')
import I18n from 'i18n-js'
window.I18n = I18n
require('i18n/translations')
// require('website/jquery.keyboard')
require('bootstrap-datepicker')
require('front/auction')
require('website/maps')
require("packs/select2setup")
require('website/acommon')
require('channels/auction_channel')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

require("trix")
require("@rails/actiontext")

// Main page scroll restoration: return user to same scroll position when they use
// the browser back button after visiting an ad (issue #512).
(function() {
  const SCROLL_STORAGE_KEY = 'monet_main_page_scroll';

  function isMainPage() {
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  // Ad detail URLs: /:ad_type/:location/:ad_title/:id (4 segments, last is numeric)
  function isAdDetailPath(pathname) {
    if (!pathname || pathname === '/') return false;
    const segments = pathname.replace(/^\/|\/$/g, '').split('/');
    return segments.length === 4 && /^\d+$/.test(segments[3]);
  }

  function saveMainPageScroll() {
    if (!isMainPage()) return;
    try {
      sessionStorage.setItem(SCROLL_STORAGE_KEY, JSON.stringify({
        x: window.scrollX || window.pageXOffset,
        y: window.scrollY || window.pageYOffset
      }));
    } catch (e) { /* ignore */ }
  }

  function applySavedScrollPosition() {
    try {
      const raw = sessionStorage.getItem(SCROLL_STORAGE_KEY);
      if (!raw) return false;
      const pos = JSON.parse(raw);
      const y = typeof pos.y === 'number' ? pos.y : 0;
      const x = typeof pos.x === 'number' ? pos.x : 0;
      window.scrollTo(x, y);
      return true;
    } catch (e) { return false; }
  }

  function restoreMainPageScroll() {
    if (!isMainPage()) return;
    try {
      const raw = sessionStorage.getItem(SCROLL_STORAGE_KEY);
      if (!raw) return;
      JSON.parse(raw); // validate
      // Restore immediately so user doesn't see a flash at top
      requestAnimationFrame(function() {
        requestAnimationFrame(function() {
          applySavedScrollPosition();
        });
      });
      // Re-apply scroll after layout stabilizes (images, ads, infinite scroll).
      // Otherwise the restored position ends up "one page up" once content loads.
      [200, 500, 1000].forEach(function(delayMs) {
        setTimeout(function() {
          if (applySavedScrollPosition()) {
            if (delayMs === 1000) sessionStorage.removeItem(SCROLL_STORAGE_KEY);
          }
        }, delayMs);
      });
    } catch (e) { /* ignore */ }
  }

  function initScrollRestoration() {
    if (!isMainPage()) return;

    // Restore scroll when returning to main page (back button or bfcache)
    restoreMainPageScroll();

    // Save scroll when user clicks a link to an ad detail page
    document.addEventListener('click', function(e) {
      const link = e.target.closest('a[href]');
      if (!link || link.target === '_blank' || link.getAttribute('rel') === 'external') return;
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript:')) return;
      try {
        const url = new URL(href, window.location.origin);
        if (url.origin !== window.location.origin) return;
        if (isAdDetailPath(url.pathname)) saveMainPageScroll();
      } catch (err) { /* ignore */ }
    }, true);
  }

  function onPageReady() {
    initScrollRestoration();
  }

  document.addEventListener('DOMContentLoaded', onPageReady);
  window.addEventListener('pageshow', function(e) {
    if (e.persisted) restoreMainPageScroll();
  });
})();

// Footer scroll detection - show footer only when user scrolls to bottom
// Scroll-to-top button - show when user has scrolled down (header starts to disappear)
document.addEventListener('DOMContentLoaded', function() {
  const SCROLL_THRESHOLD = 200; // Show arrow when user has scrolled down this much

  function checkFooterVisibility() {
    const footer = document.querySelector('.footer');
    if (!footer) return;

    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollBottom = scrollTop + windowHeight;

    // Show footer when:
    // 1. User is near the bottom (within 100px), OR
    // 2. Page is shorter than viewport (no scrolling needed)
    if (documentHeight <= windowHeight || scrollBottom >= documentHeight - 100) {
      footer.classList.add('footer-visible');
    } else {
      footer.classList.remove('footer-visible');
    }
  }

  function checkScrollToTopVisibility() {
    const btn = document.getElementById('scroll-to-top');
    if (!btn) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > SCROLL_THRESHOLD) {
      btn.classList.add('scroll-to-top--visible');
    } else {
      btn.classList.remove('scroll-to-top--visible');
    }
  }

  function scrollToTop(e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  // Check on scroll
  window.addEventListener('scroll', function() {
    checkFooterVisibility();
    checkScrollToTopVisibility();
  });

  // Check on page load (in case page is already at bottom or too short)
  checkFooterVisibility();
  checkScrollToTopVisibility();

  // Check on resize (in case window size changes)
  window.addEventListener('resize', checkFooterVisibility);

  // Scroll-to-top click: smooth scroll only, no navigation (keeps search criteria)
  const scrollToTopBtn = document.getElementById('scroll-to-top');
  if (scrollToTopBtn) {
    scrollToTopBtn.addEventListener('click', scrollToTop);
  }
});